var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"items":_vm.country_areas,"item-text":"name","item-value":"id","loading":_vm.loading,"value":_vm.country_area,"return-object":"","disabled":_vm.loading,"color":_vm.color,"outlined":_vm.outlined,"dense":_vm.dense},on:{"change":_vm.handleSelect}},'v-autocomplete',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }